import * as go from 'gojs';
import theme from 'theme/theme';
import { TableRowPanel } from '../Panels/TableRowPanel';
import { getTitleStroke } from '../Panels/baseUnitUtils';
import { getFont } from '../utils/font';
import { PanelNames } from '../utils/panelNames';
import type { ParticleSizeDistibutionListPanelInterface } from 'gojs/panelData';
import { GoJsFlowGraph } from './goJsGraphPanel';

const $ = go.GraphObject.make;

export const particleSizeDistributionList = $(
  go.Panel,
  'Viewbox',
  $(
    go.Panel,
    'Vertical',
    $(
      go.TextBlock,
      {
        alignment: go.Spot.Left,
        margin: new go.Margin(0, 0, 6, 0),
        name: PanelNames.PARTICLE_SIZE_DISTRIBUTION_SIZE_LIST,
      },
      new go.Binding('text', '', (node) => {
        if (node.inputFlow) {
          return 'Plant feed size distribution';
        }
        return 'Particle size distribution list';
      }),
      getFont({ weight: 700 }),
      getTitleStroke(),
    ),
    $(
      go.TextBlock,
      {
        stroke: theme.palette.grey[900],
        alignment: go.Spot.Left,
        margin: new go.Margin(0, 0, 6, 0),
      },
      new go.Binding('visible', '', (node) => !!node.inputFlow),
      new go.Binding('text', '', (node) => {
        if (node.inputFlow.psdName === 'Custom') {
          return node.inputFlow.otherPsdName ?? 'Custom';
        } else {
          return node.inputFlow.psdName;
        }
      }),
      getFont({ weight: 500 }),
    ),
    $(
      go.TextBlock,
      {
        stroke: theme.palette.grey[900],
        alignment: go.Spot.Left,
        margin: new go.Margin(0, 0, 6, 0),
      },
      new go.Binding(
        'text',
        '',
        ({ metricName }: ParticleSizeDistibutionListPanelInterface) =>
          metricName,
      ),
      getFont({ weight: 500 }),
    ),
    $(
      go.Panel,
      'Vertical',
      { alignment: go.Spot.Left },
      new go.Binding(
        'itemArray',
        'tableData',
        (tableData: ParticleSizeDistibutionListPanelInterface['tableData']) =>
          tableData,
      ),
      {
        itemTemplate: TableRowPanel,
      },
    ),
  ),
);

export const particleSizeDistributionGraph = $(
  go.Panel,
  'Viewbox',
  {
    width: 375,
    height: 300,
    name: 'PSD_GRAPH',
    maxSize: new go.Size(1000, 800),
    minSize: new go.Size(250, 200),
  },
  new go.Binding('height', 'height').makeTwoWay(),
  new go.Binding('width', 'width').makeTwoWay(),
  $(
    go.Panel,
    'Vertical',
    { margin: 0 },
    $(
      go.TextBlock,
      {
        alignment: go.Spot.Left,
        margin: new go.Margin(0, 0, 8, 0),
        name: PanelNames.PARTICLE_SIZE_DISTRIBUTION_SIZE_GRAPH,
      },
      getFont({ weight: 700, scale: 1.5 }),
      getTitleStroke(),
      new go.Binding('text', '', (node) => {
        if (!node.inputFlow) {
          return 'Particle size distribution graph';
        }
        if (node.inputFlow.psdName === 'Custom') {
          return (
            'Plant feed size distribution - ' + node.inputFlow.otherPsdName ||
            'Custom'
          );
        } else {
          return 'Plant feed size distribution - ' + node.inputFlow.psdName;
        }
      }),
    ),
    $(
      go.Panel,
      'Viewbox',
      $(
        go.Picture,
        new go.Binding('element', 'flowPropertiesGraph', GoJsFlowGraph),
        new go.Binding('alignment', 'alignment', go.Spot.parse).makeTwoWay(
          go.Spot.stringify,
        ),
      ),
    ),
  ),
);
